import {SliderComponent} from "../SliderDefault/SliderComponent";

export class SliderCarouselComponent extends SliderComponent {
  constructor(element, options) {

    // see http://ganlanyuan.github.io/tiny-slider/#options
    let defaultOptions = {
      autoWidth: true,
      fixedWidth: 300,
      gutter: 20,
      loop: false,
      items: 1,
      responsive: {
        782: {
          items: 2,
          fixedWidth: false
        },
        960: {
          items: 3
        },
        1320: {
          items: 4
        }
      }
    };
    super(element, Object.assign(defaultOptions,options));
  }

  init() {
    // Récupérer la largeur du premier élément avant l'initialisation du slider
    const firstSlide = this.element[0].firstElementChild;
    if (firstSlide) {
      console.log(firstSlide.offsetWidth);
      let gap = 0;
      if (this.options.gutter) {
        gap = this.options.gutter;
      }
      this.options.fixedWidth = firstSlide.offsetWidth;
    }
    super.init();
  }
}


window.pew.addRegistryEntry({key: 'wdf-slider-carousel', domSelector: '.wdf-slider-carousel', classDef: SliderCarouselComponent});
